import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-statistics',
  templateUrl: './icon-statistics.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconStatisticsComponent {}
